'use client';
import { Center, Spinner } from '@chakra-ui/react';
import React from 'react';

export default function LoadingScreen() {
  return (
    <Center w={'full'} h={'full'} bg={'background.main.base'}>
      <Spinner size="xl" />
    </Center>
  );
}
